
// shader that draws the active texture (image)
export const fragment = `
precision highp float;

uniform sampler2D texture;

varying vec2 v_uv;
varying vec4 v_color;

void main() {
    vec4 sample = texture2D(texture, v_uv);
    gl_FragColor = vec4(sample.rgb * sample.a, sample.a) * v_color;
}
`;